import { extensions, Image } from '@archetelos/editor';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ImageNodeView } from './ImageNodeView';

// The composer uses the shared schema (so it can't drift from the renderers) but
// swaps the plain image node for one with a React NodeView — the author must see
// the real image, not a placeholder. The renderers keep the plain node.
const ImageWithNodeView = Image.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
});

export const composerExtensions = [
  ...extensions.filter((e) => e.name !== 'image'),
  ImageWithNodeView,
];
